import qs from 'query-string'
import { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Dialog } from '@loadsmart/miranda-react'

import { BID_STATUS } from 'legacy/constants/bids'
import { LoadBoardContext, LOAD_BOARD_ACTIONS } from 'legacy/contexts/loadBoard'
import { getBids } from 'legacy/services/bids'
import sentry from 'legacy/utils/sentry'
import user from 'legacy/utils/user'

import { BidDialog } from './BidDialog/BidDialog'

function BidManager() {
  const [{ bidOfferUUID }, dispatch] = useContext(LoadBoardContext)

  const isBidDialogOpen = Boolean(bidOfferUUID)

  const { pathname, search } = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (user.isLoggedIn()) {
      async function fetchBids() {
        try {
          const { data: bids } = await getBids()

          // We only want active bids here because these are the ones that the user should take action
          const activeBids = bids.filter(
            bid => bid.status === BID_STATUS.AWARDED || bid.status === BID_STATUS.PENDING
          )
          if (activeBids.length)
            dispatch({
              type: LOAD_BOARD_ACTIONS.UPSERT_BIDS,
              payload: activeBids,
            })
        } catch (error) {
          sentry.log(error)
        }
      }
      fetchBids()
    }
  }, [dispatch])

  useEffect(() => {
    const query = qs.parse(search)
    if (bidOfferUUID && !query.bidding) {
      // Closes bid dialog if url search param isn't present
      dispatch({
        type: LOAD_BOARD_ACTIONS.CLOSE_BID_DIALOG,
        payload: bidOfferUUID,
      })
    } else if (!bidOfferUUID && query.bidding) {
      // Cleanup URL if Bidding Dialog isn't open
      delete query.bidding
      history.replace(`${pathname}?${qs.stringify(query)}`)
    }
  }, [bidOfferUUID, search, dispatch, pathname, history])

  return <Dialog open={isBidDialogOpen}>{isBidDialogOpen && <BidDialog />}</Dialog>
}

export { BidManager }
